import queryString from 'query-string';

import { del, getJson, postJson, putJson } from 'utils/http';

import {
  CmsDashboardApiPage,
  CmsDashboardApiPageInfo,
} from './types/CmsDashboardApiPage';

export async function fetchCmsDashboardApiPageById(
  pageId: string
): Promise<CmsDashboardApiPage> {
  const { page } = await getJson<{ page: CmsDashboardApiPage }>(
    `/data/cms/pages/${pageId}`
  );
  return page;
}

export async function createCmsDashboardApiPage(
  subsiteId: string,
  pageInfo: CmsDashboardApiPageInfo
): Promise<CmsDashboardApiPage> {
  const { page } = await postJson<{ page: CmsDashboardApiPage }>(
    `/data/cms/sub-sites/${subsiteId}/pages`,
    pageInfo
  );

  return page;
}

export async function updateCmsDashboardApiPage(
  pageId: string,
  pageInfo: CmsDashboardApiPageInfo
): Promise<CmsDashboardApiPage> {
  const { page } = await putJson<{ page: CmsDashboardApiPage }>(
    `/data/cms/pages/${pageId}`,
    pageInfo
  );

  return page;
}

export function deleteCmsDashboardApiPage(pageId: string) {
  return del(`/data/cms/pages/${pageId}`);
}

export async function publishCmsDashboardApiPage(
  pageId: string
): Promise<CmsDashboardApiPage> {
  const { page } = await postJson<{ page: CmsDashboardApiPage }>(
    `/data/cms/pages/${pageId}/publish`
  );

  return page;
}

export async function unpublishCmsDashboardApiPage(
  pageId: string
): Promise<CmsDashboardApiPage> {
  const { page } = await postJson<{ page: CmsDashboardApiPage }>(
    `/data/cms/pages/${pageId}/unpublish`
  );

  return page;
}

export async function fetchCmsDashboardApiPagesByMasterId(
  masterIds: string[]
): Promise<CmsDashboardApiPage[]> {
  const params = queryString.stringify({ id: masterIds });

  const { pages } = await getJson<{ pages: CmsDashboardApiPage[] }>(
    `/data/cms/pages-by-master-id?${params}`
  );

  return pages;
}

export function fetchCmsDashboardApiPageWithType(pageUrl: string): Promise<{
  data: CmsDashboardApiPage;
  type: string;
}> {
  return getJson(`/data/website/contents/${pageUrl}`);
}
